import React, { useEffect } from 'react';
import { useWidget } from 'components/Widget/useWidget';
import ChartBody from 'modules/DashboardModule/charts/components/ChartBody';
import ChartLoading from 'components/charts/components/ChartLoading';
import NoResultFound from 'components/charts/components/NoResultFound';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ninjaApi from 'store/redux/apis';

const IntegrationChartContent = ({ height, widget_key }) => {
  const [getIntegrationsReports, { data: shopify = [], isLoading, isFetching }] =
    ninjaApi.useLazyIntegrationsReportsQuery();
  const { filters, chartConfig } = useWidget();
  const { date_from, date_to } = useWidgetDate(widget_key);

  useEffect(() => {
    const params = {
      load_chart: chartConfig?.load_chart,
      date_from: date_from,
      date_to: date_to,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }

    if (params?.date_from) {
      getIntegrationsReports(params).unwrap();
    }
  }, [filters, chartConfig?.load_chart]);

  if (isLoading || isFetching) {
    return <ChartLoading height={height} />;
  }

  if (!shopify?.data?.length) {
    return <NoResultFound height={height} />;
  }

  return <ChartBody height={height} data={shopify?.data} />;
};

export default IntegrationChartContent;
